export default __webpack_public_path__ + "images/2_Bestill_varer.webp";